import { CamerasDesktopView } from './CamerasDesktopView';

export function CamerasMobileView() {
  return <CamerasDesktopView />;
}
